import styled, { css } from 'styled-components';
import { darkLava } from '@/app/components/search/styles/colors.ts';

export const Container = styled.div<{ topSwirl: string; rightSwirl: string }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 32px;
  background-color: ${darkLava};
  border-radius: 8px;
  color: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};

  ${({ topSwirl, rightSwirl }) => css`
    background-image: url(${topSwirl});
    background-repeat: no-repeat;
    background-position: right top;
    background-size: 50%;

    @media (max-width: 767px) {
      background-image: url(${rightSwirl});
      background-size: contain;
    }
  `};

  @media (max-width: 767px) {
    flex-direction: column;
    margin-bottom: 10px;
    padding: 16px;

    button,
    a {
      width: 100%;
    }
  }
`;

export const IconContainer = styled.div`
  flex-shrink: 0;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin-right: 4px;
  margin-left: 16px;

  @media (max-width: 767px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const Title = styled.h3`
  font-size: 20px;
  line-height: 30px;
`;

export const Text = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

export const PayOff = styled.div`
  position: relative;
  padding: 10px 18px 10px 10px;
  margin-left: auto;
  flex-shrink: 0;
  font-family: var(--font-lastminute-sans), sans-serif;

  span {
    font-size: 14px;
    line-height: 22px;
    display: inline-block;
    vertical-align: middle;
  }

  svg,
  img {
    vertical-align: middle;
  }

  @media (max-width: 767px) {
    padding-right: 0;
    margin-bottom: 10px;

    svg,
    img {
      position: absolute;
      left: 50%;
      top: 30px;
      transform: translate(-50%, 0) rotate(145deg);
    }
  }
`;

export const Spacer = styled.div`
  @media (min-width: 768px) {
    height: 100%;
    flex-grow: 1;
    max-width: 48px; // 64px - 16px
    min-width: 0;
  }
`;
